import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { User } from '../models/user_detail';

@Injectable({
  providedIn: 'root',
})
export class SignupWizardServerService {
  user_url = {
    registerUser: environment.URL + 'customer/register', //1st
    verifyOtp: environment.URL + 'customer/verify', //2nd
    resendOtp: environment.URL + 'customer/resend-otp',
    getPlans: environment.URL + 'public/plan/retrieve/all', //3rd
    createOrder: environment.URL + 'kreta/order/create',
    fetchOrderDetails: environment.URL + 'kreta/order/get',
    subscribe: environment.URL + 'kreta/subscription/subscribe',
    getSubscriptionDetails: environment.URL + 'public/subscription/details',
    markPlanAsSelected: environment.URL + 'public/customer/plan-selected', //4th
    getNewSubscriptionPlans:
      environment.URL + 'public/plan/retrieve/all/newSubscription', //3rd
    getUpgradePlans: environment.URL + 'public/plan/retrieve/all/upgradeOnly',
    getCustomPlanByName: environment.URL + 'public/plan/custom-plan/get',
    getPlanById: environment.URL + 'public/plan/custom/get',
  };

  constructor(private http: HttpClient) {}

  /**
   * Registers a user with the provided details
   * @param userDetails - The user details to be registered
   * @returns {Observable<any>} - Observable containing the registration response
   */
  registerUser(userDetails: User): Observable<any> {
    return this.http.post(this.user_url.registerUser, userDetails);
  }

  /**
   * Verifies the OTP entered by the user
   * @param otpData - The OTP verification data
   * @returns {Observable<any>} - Observable containing the OTP verification response
   */
  verifyOtp(otpData: any): Observable<any> {
    return this.http.post(this.user_url.verifyOtp, otpData);
  }

  /**
   * Resends the OTP to the user's email
   * @param email - The user's email address
   * @returns {Observable<any>} - Observable containing the response of OTP resend
   */
  resendOtp(email: string): Observable<any> {
    return this.http.post(this.user_url.resendOtp, { email });
  }

  /**
   * Retrieves all available subscription plans
   * @returns {Observable<any>} - Observable containing the available plans
   */
  // getPlans(): Observable<any> {
  //   return this.http.get(this.user_url.getPlans);
  // }
  getPlans(): Observable<any> {
    return this.http.get(this.user_url.getNewSubscriptionPlans);
  }

  /**
   * Retrieves a single plan by its id. Used by the checkout wizard when
   * arriving via ?plan=<id> for a plan that is NOT in the public list
   * (e.g. isActive=false private/promotional plans). Backend route filters
   * by isDisable only, so disabled plans correctly 404 here.
   */
  getPlanById(id: string): Observable<any> {
    return this.http.get(`${this.user_url.getPlanById}/${id}`);
  }

  /**
   * Creates a new order with Cashfree
   * @param orderDetails - The order details
   * @returns {Observable<any>} - Observable containing the Cashfree order response
   */
  createOrder(orderDetails: any): Observable<any> {
    return this.http.post(this.user_url.createOrder, orderDetails);
  }

  createSubscribe(subDetails: any): Observable<any> {
    return this.http.post(this.user_url.subscribe, subDetails);
  }

  // Method to fetch order details by orderId
  getOrderById(orderId: number): Observable<any> {
    return this.http.get<any>(`${this.user_url.fetchOrderDetails}/${orderId}`);
  }

  // flag of user had selected/interested plan
  markPlanAsSelected(userId: string): Observable<any> {
    return this.http.post(`${this.user_url.markPlanAsSelected}/${userId}`, {});
  }

  // Fetch subscription details
  getSubscriptionDetails(dsSubscriptionId: string): Observable<any> {
    return this.http.get<any>(
      `${this.user_url.getSubscriptionDetails}/${dsSubscriptionId}`,
    );
  }

  getUpgradePlans(currentPlanId: any, tenantId?: any): Observable<any> {
    // tenantId lets the server read the customer's REAL mandate ceiling
    // (subscription.maxAmount) to pick the seamless (== ceiling) variant.
    const base = `${this.user_url.getUpgradePlans}/${currentPlanId}`;
    const url = tenantId != null ? `${base}?tenantId=${tenantId}` : base;
    return this.http.get(url);
  }

  getCustomPlanByName(planName: any): Observable<any> {
    return this.http.get(`${this.user_url.getCustomPlanByName}/${planName}`);
  }
}
